export default __webpack_public_path__ + "assets/images/illustration-own-economy-352a.png";